import { render, staticRenderFns } from "./AtomStructuredText.vue?vue&type=template&id=262fee98&"
import script from "./AtomStructuredText.vue?vue&type=script&lang=js&"
export * from "./AtomStructuredText.vue?vue&type=script&lang=js&"
import style0 from "./AtomStructuredText.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AtomStructuredText.vue"
export default component.exports